import { render, staticRenderFns } from "./Feature6Demo.vue?vue&type=template&id=74b7d9c8&scoped=true&"
import script from "./Feature6Demo.vue?vue&type=script&lang=js&"
export * from "./Feature6Demo.vue?vue&type=script&lang=js&"
import style0 from "./Feature6Demo.vue?vue&type=style&index=0&id=74b7d9c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b7d9c8",
  null
  
)

export default component.exports